module.exports = __webpack_public_path__ + "static/rendeavour-b9db61122bbbb1af5227ef622df0f71a.png";